import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconGoogleadvertiser(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="currentColor"
          d="M5.85 2.853a2.5 2.5 0 1 1 4.33 2.5l-4.5 7.794a2.5 2.5 0 1 1-4.33-2.5l4.5-7.794z"
        />
        <path
          fill="currentColor"
          d="M5.85 5.353a2.5 2.5 0 1 1 4.33-2.5l4.5 7.794a2.5 2.5 0 1 1-4.33 2.5l-4.5-7.794z"
        />
        <circle cx="3.5" cy="11.888" r="2.5" fill="currentColor" />
      </g>
    </Icon>
  )
}
